import MainPage from './components/MainPage'
import BadgesPage from './components/BadgesPage'
import GenericLogin from './components/GenericLogin'
import RequiresLti from './components/RequiresLti'

import log from './middleware/log';
import auth from './middleware/auth';
import genericAuth from './middleware/genericAuth';
import ltiLaunch from './middleware/ltiLaunch';
import langSwitch from './middleware/langSwitch';

const routes = [
    {
        path: '/badges',
        name: 'badgesPage',
        component: BadgesPage,
        meta: {
            middleware: [auth, log]
        }
    },
    {
        path: '/',
        name: 'mainPage',
        component: MainPage,
        meta: {
            middleware: [auth, log]
        }
    },
    {
        path: '/lti',
        name: 'ltiLaunch',
        meta: {
            middleware: [ltiLaunch]
        }
    },
    {
        path: '/requiresLti',
        name: 'requiresLti',
        component: RequiresLti
    },
    {
        path: '/genericLogin',
        name: 'routeGenericLogin',
        component: GenericLogin
    },
    {
        path: '/language_switch',
        name: 'routeLanguageSwitch',
        meta: {
            middleware: [langSwitch]
        }
    },
    {
        path: '*',
        redirect: '/'
    },
];


export default routes;
